import * as React from "react";
import type {
    RenderElementProps,
    RenderLeafProps,
    RenderPlaceholderProps,
} from "slate-react";

import {color} from "@khanacademy/wonder-blocks-tokens";
import {Reference} from "@khan/slate-helpers";

import {MathEditor} from "../math-editor/math-editor.tsx";

// eslint-disable-next-line react-refresh/only-export-components -- porting over from old code.
export const renderLeaf = (props: RenderLeafProps): React.ReactElement => (
    <span
        // The following is a workaround for a Chromium bug where,
        // if you have an inline at the end of a block,
        // clicking the end of a block puts the cursor inside the inline
        // instead of inside the final {text: ''} node
        // https://github.com/ianstormtaylor/slate/issues/4704#issuecomment-1006696364
        style={
            props.leaf.text === ""
                ? {
                      paddingLeft: "0.1px",
                  }
                : undefined
        }
        {...props.attributes}
    >
        {props.children}
    </span>
);

// eslint-disable-next-line react-refresh/only-export-components -- porting over from old code.
export const renderElement = (
    props: RenderElementProps,
): React.ReactElement => {
    const {element, ...rest} = props;

    switch (element["type"]) {
        case "math-editor":
            const mathElement = element;
            return (
                <MathEditor
                    element={mathElement}
                    {...rest}
                    canSendMessage={true}
                />
            );
        case "reference":
            const referenceElement = element;
            return <Reference element={referenceElement} {...rest} />;
        case "paragraph":
            return (
                <p
                    {...props.attributes}
                    style={{
                        // Override global tag styles with local styles
                        fontSize: "inherit",
                        margin: "unset",
                    }}
                >
                    {props.children}
                </p>
            );
        default:
            return <span {...props.attributes}>{props.children}</span>;
    }
};

// eslint-disable-next-line react-refresh/only-export-components -- porting over from old code.
export const renderPlaceholder = (
    props: RenderPlaceholderProps,
): React.ReactElement => (
    <span
        {...props.attributes}
        style={{
            ...props.attributes.style,
            color: color.offBlack64,
            opacity: "unset",
        }}
    >
        {props.children}
    </span>
);

// Put this at the start and end of an inline component to work around this Chromium bug:
// https://bugs.chromium.org/p/chromium/issues/detail?id=1249405
export const InlineChromiumBugfix = () => (
    <span
        contentEditable={false}
        style={{
            fontSize: 0,
        }}
    >
        {String.fromCodePoint(160) /* Non-breaking space */}
    </span>
);
